<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>speaker_not_blocked</title>
    <path
      fill="#679940"
      d="M21.973 29.387l-11.787-6.773c-0.213-0.107-0.48-0.107-0.64 0-0.213 0.107-0.32 0.32-0.32 0.587v4h-0.8l-1.707-5.333c-0.107-0.267-0.32-0.48-0.64-0.48h-3.147v-8.907h3.84v4.853c0 0.373 0.32 0.64 0.64 0.64s0.64-0.32 0.64-0.64v-5.493c0-0.373-0.32-0.64-0.64-0.64h-5.173c-0.373 0-0.64 0.32-0.64 0.64v10.24c0 0.373 0.32 0.64 0.64 0.64h3.36l1.653 5.28c0.107 0.267 0.32 0.48 0.64 0.48h1.973c0.373 0 0.64-0.32 0.64-0.64v-3.52l10.773 6.187c0.107 0.053 0.213 0.107 0.32 0.107 0.213 0 0.48-0.107 0.587-0.32 0.213-0.32 0.107-0.747-0.213-0.907z"
    />
    <path
      fill="#679940"
      d="M29.6 0.427c-0.213-0.107-0.48-0.107-0.64 0l-18.613 10.613c-0.213 0.107-0.32 0.373-0.32 0.64v8.107c0 0.213 0.107 0.48 0.32 0.587l18.613 10.613c0.107 0.053 0.213 0.107 0.32 0.107s0.213-0.053 0.32-0.107 0.32-0.32 0.32-0.587v-29.387c0-0.213-0.107-0.48-0.32-0.587zM28.587 29.227l-17.28-9.813v-7.413l13.333-7.627v18.187c0 0.373 0.32 0.64 0.64 0.64s0.64-0.32 0.64-0.64v-18.933l2.613-1.493v27.093z"
    />
  </svg>
</template>

<script>
export default {
    name: "CampaignsIcon"
}
</script>


// WEBPACK FOOTER //
// src/icons/CampaignsIcon.vue